// test1986
(1986 && 0);
